var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-wrapper",attrs:{"id":"home-wrapper"}},[_c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:('三丽鸥联动-pc'),expression:"'三丽鸥联动-pc'"}]},[_c('div',{staticClass:"logo"}),_vm._v(" "),_c('div',{staticClass:"copyright"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ca19d91","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/sakura/sanliouLinkage/pc/index.vue
// module id = null
// module chunks = 